  /**
   * @memberof SMART2
   * @ngdoc directive
   * @name Tooltip
   * @description This directive is useful for creating a tooltip.
   * 
   * @attr {String} position
   *    Tooltip position. Possible values are left, right, top, bottom. Default value is 'left'.
   * @attr {Number} delay
   *    Tooltip delay. Default value is '250'.
   * @attr {String} tooltip
   *    Tooltip message
   * 
   * @example
   Usage:
   <span smart-tooltip position="top" delay="500" message="Tooltip message"></span>
   */

(function () {
    'use strict';
    angular.module('SMART2').directive('smartTooltip', ['$window',function ($window) {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                customStyle: "="
            },
            link: function (scope, element, attrs) {
                var onMessage = attrs.$observe('message', function (value) {
                    element.attr('data-tooltip', value);
                });
                
                var tooltipPosition = attrs.position;
                if($window.isRTL){
                    tooltipPosition =  attrs.position == 'left'? attrs.position = 'right': attrs.position == 'right'? attrs.position = 'left':attrs.position;
                }                
               
                element.attr('data-position', tooltipPosition ? tooltipPosition : 'left');
                element.attr('data-delay', attrs.delay ? attrs.delay : '50');
                element.attr('data-tooltip', attrs.message ? attrs.message : '');
                element.addClass('tooltipped');
                if (typeof scope.customStyle != "undefined") {
                    var optionsObject = {
                        "customStyle": scope.customStyle
                    };
                }
                element.tooltip(optionsObject);
                element.on('click', function () {
                    element.trigger('mouseleave');
                });
                //  Destroy tooltip on scope destroy
                scope.$on('$destroy', function () {
                    element.tooltip('remove');
                    onMessage();
                });
            }
        };
    }]);
})();